;(function ($) {
  "use strict";
  $(document).ready(function () {
    linksInit();
  });
})(jQuery);

function linksInit() {
  var linkSelectors = [
    '.box.link',
    '.list-item.link',
    '.notify-box--with-link',
  ];

  $(linkSelectors.join()).on('click', function (e) {
    var link = $(this).find('a').first();

    if ($(e.target).is('a')) return;

    if (link.length && link.attr('href') != '' && link.attr('href') != '#') {
      window.location.href = link.prop('href');
    }
    return false;
  });

  $(linkSelectors.join()).focusin(function (e) {
    $(this).addClass('hover');
  });

  $(linkSelectors.join()).focusout(function (e) {
    $(this).removeClass('hover');
  });
}
